import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';

export const httpLink = () =>
  createHttpLink({
    uri: '/home-and-auto/graphql-bearer',
  });

const client = new ApolloClient({
  name: 'home-and-auto-graphql',
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          vehicleData: {
            keyArgs: (_, context) => {
              const { year, make, model } = context.variables;

              return `${year}${make}${model}`;
            },
          },
        },
      },
    },
  }),
  link: httpLink(),
});

export default client;
